<div class="nx-sort-select-container" [ngClass]="className">
  <!-- Dropdown for field selection -->
  <p-dropdown
    class="nx-sort-dropdown"
    [styleClass]="'sort'"
    [placeholder]="placeholder"
    [appendTo]="appendTo"
    [ngModel]="selectedField()"
    (ngModelChange)="onFieldChange($event)"
    [options]="effectiveOptions()"
    optionLabel="label"
    dataKey="key"
    [showClear]="false">
  </p-dropdown>

  <!-- Direction toggle button -->
  <button
    type="button"
    class="nx-sort-direction-button"
    [class.disabled]="!selectedField() || isNoSortSelected()"
    [disabled]="!selectedField() || isNoSortSelected()"
    [pTooltip]="getDirectionTooltip()"
    tooltipPosition="top"
    (click)="onDirectionToggle()">
    <i [class]="getDirectionIcon()"></i>
  </button>
</div>
